<template>
  <div>
    CPU专区
  </div>

</template>

<script>
    export default {
        name: "CPUZone"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/index/CpuZone.vue